import React, {FC} from "react";
import {FeAvailability} from "../../../availibilities/redux/types";
import {makeStyles} from "@material-ui/core/styles";
import {CardProps, DialogContent, Grid, IconButton, Typography} from "@material-ui/core";
import {DeleteOutline, EditOutlined} from "@material-ui/icons";
import {LabeledTextDisplay} from "../../../../sharedComponents/LabeledTextDisplay";
import {formatDate} from "../../../../date.utils";
import {useHistory, useRouteMatch} from "react-router-dom";
import {EditAvailabilityDialog} from "../../../availibilities/sharedComponents/EditAvailabilityDialog";
import {CancelAvailabilityDialog} from "../../../availibilities/sharedComponents/CancelAvailabilityDialog";

const useStyles = makeStyles((theme) => ({
    dialogContent: {
        position: "relative"
    },
    actions: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1)
    },
    timeContainer: {
        marginTop: 4
    }
}))

interface CalendarDayDialogAvailabilityProps {
    availability: FeAvailability;
    showActions: boolean;
    cardProps?: CardProps;
}

export const CalendarDayDialogAvailability: FC<CalendarDayDialogAvailabilityProps> = ({
                                                                                          availability,
                                                                                          cardProps,
                                                                                          showActions
                                                                                      }) => {
    const history = useHistory();
    const {url} = useRouteMatch();
    const navigateToCancelAvailability = () => {
        history.replace(`${url}?mode=edit#cancel-availability`)
    };

    const navigateToEditAvailability = () => {
        // toggleDialog();
        history.replace("?mode=edit#availability");
    }

    const classes = useStyles();
    return (
        <React.Fragment>
            <CancelAvailabilityDialog availability={availability}/>
            <EditAvailabilityDialog availability={availability}/>
            <DialogContent className={classes.dialogContent} {...cardProps}>
                <Typography
                    variant="h6"
                    color="secondary"
                >
                    Verfügbarkeit
                </Typography>
                {showActions &&
                <div className={classes.actions}>
                    <IconButton onClick={navigateToEditAvailability}>
                        <EditOutlined/>
                    </IconButton>
                    <IconButton onClick={navigateToCancelAvailability}>
                        <DeleteOutline/>
                    </IconButton>
                </div>}
                <Grid container className={classes.timeContainer}>
                    <Grid item xs={12}>
                        <LabeledTextDisplay
                            label={"Datum"}
                            value={formatDate(availability.from, "EEEE, dd.MM.yyyy")}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <LabeledTextDisplay
                            label={"Start"}
                            value={formatDate(availability.from, "HH:mm")}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <LabeledTextDisplay
                            label={"Ende"}
                            value={formatDate(availability.to, "HH:mm")}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
        </React.Fragment>
    )
}
